import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useI18nContext } from '@procore/core-react';
import { useStyles } from './ExploreLatestProjects.styles';
import ProjectCard from './ProjectCard';
import LinkWithArrow from '../ButtonsLinks/LinkWithArrow';
import { type ProjectTile } from '../../types/project';

const ExploreLatestProjects = ({ projects }: { projects: ProjectTile[] }) => {
  const I18n = useI18nContext();
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Typography variant="h1" className={classes.title}>
        {I18n.t('components.explore_latest_projects.label')}
      </Typography>
      <Box className={classes.projectsContainer}>
        {projects.map((p, index) => (
          <Box key={index} className={classes.projectCard}>
            <ProjectCard project={p} />
          </Box>
        ))}
      </Box>
      <Box className={classes.readMoreContainer}>
        <LinkWithArrow
          buttonLabel={I18n.t(
            'components.explore_latest_projects.button_label'
          )}
          buttonLink="/projects/search"
          dataTrackClick="Explore Latest Projects"
          centered
          analyticsLabel="Explore Latest Projects"
        />
      </Box>
    </Container>
  );
};

export default ExploreLatestProjects;
